module.exports = __webpack_public_path__ + "static/media/fast_edit.ec056e1e.svg";